import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

const publicAPI = axios.create({
  baseURL: `${BASE_URL}/api/public`,
});

export default publicAPI;
